import React from 'react'
import styled from 'styled-components'
import { mobile } from '../responsive'
import { Link } from 'react-router-dom'



const Container = styled.div`
    flex : 1;
    margin: 3px;
    height : 90vh;
    position : relative;
`
const Image = styled.img`
    width : 100%;
    height: 100%;
    object-fit : cover;     
    ${mobile({ height: "20vh" })};


    `



const Info = styled.div`
    position: absolute;
    top : 0;
    left : 0;
    width: 100%;
    height: 100%;
    display : flex;
    align-items: center;
    justify-content: center;
    flex-direction : column;
`
const Title = styled.h1`

color : white;
margin-bottom: 2px;

`
const Button = styled.button`
border : none;
padding : 10px;
background-color: white;
color : gray;
cursor : pointer;
`



const CategoryItem = ({ item }) => {
    return (
        <Container>
            <Image src={item.img} />
            <Info>
                <Title>
                    {item.title}
                </Title>
                <Link to="/product-list" style={{ textDecoration: 'none', color: 'black' }}>
                <Button>SHOP NOW</Button>
                </Link>
            </Info>
        </Container>
    )
}

export default CategoryItem